export default "__VITE_ASSET__BCXJGNdZ__"